import { getTaskStatusCode } from "./models/task-status";

export const statusProject = [
  {
    text: "見込み",
    value: 6
  },
  {
    text: "見積中",
    value: 7
  },
  {
    text: "見積提出",
    value: 8
  },
  {
    text: "受注",
    value: 9
  },
  {
    text: "施工前",
    value: 10
  },
  {
    text: "施工中",
    value: 11
  },
  {
    text: "施工終了",
    value: 12
  },
  {
    text: "未請求",
    value: 13
  },
  {
    text: "請求済",
    value: 14
  },
  {
    text: "入金済",
    value: 15
  }
];

export const statusSearch = [
  {
    text: "(ステータス)",
    value: ""
  },
  {
    text: "失注",
    value: 16
  },
  {
    text: "保留",
    value: getTaskStatusCode("保留")
  },
  ...statusProject
];

export const listStatus: string[] = [
  "失注",
  "保留",
  "見込み",
  "見積中",
  "見積提出",
  "受注",
  "施工前",
  "施工中",
  "施工終了",
  "未請求",
  "請求済",
  "入金済"
];

export const statusSearchDashboard = [
  {
    text: "失注",
    value: 16
  },
  {
    text: "保留",
    value: getTaskStatusCode("保留")
  },
  {
    text: "見込み",
    value: 6
  },
  {
    text: "見積中",
    value: 7
  },
  {
    text: "見積提出",
    value: 8
  },
  {
    text: "受注",
    value: 9
  },
  {
    text: "未着工",
    value: getTaskStatusCode("未着工")
  },
  {
    text: "施工前",
    value: getTaskStatusCode("施工前")
  },
  {
    text: "施工中",
    value: getTaskStatusCode("施工中")
  },
  {
    text: "施工終了",
    value: getTaskStatusCode("施工終了")
  },
  {
    text: "未請求",
    value: 13
  },
  {
    text: "請求済",
    value: 14
  },
  {
    text: "入金済",
    value: 15
  }
];

export function getStatusCode(name: string, isNewProject: boolean = false) {
  let status: any = statusSearchDashboard.find(item => item.text == name);

  if (isNewProject) {
    status = statusSearch.find(item => item.text == name);
  }

  if (status) {
    return status.value;
  }

  return 1;
}

export function getStatusName(number: number): string {
  const status = statusSearch.find(item => item.value == number);
  if (status) {
    return status.text;
  }

  return "";
}

export function getValueStatusInvoice(hasStatusSuccess = false) {
  const data = ["未請求", "請求済", "入金済"];

  if (hasStatusSuccess) {
    data.push("施工終了");
  } 
  
  return data.map(item => getStatusCode(item, true));
}
